"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles = {
    groupContainer: {
        padding: '5px',
        borderRadius: '5px',
        margin: '10px 0px',
        backgroundColor: 'white',
    },
    header: {
        borderBottom: '1px solid #e8e8e8',
        paddingBottom: '5px',
        fontWeight: 'bold',
        color: '#4a4a4a',
        marginBottom: '10px',
        fontSize: '12px',
    },
};
function PreferencesGroup({ children, header }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: styles.groupContainer, children: [header &&
                (typeof header === 'string' ? ((0, jsx_runtime_1.jsx)("p", { style: styles.header, children: header })) : (header(styles.header))), children] }));
}
exports.PreferencesGroup = PreferencesGroup;
